import { hideTooltip } from 'modules/application/tooltips';

export const hidePlaybackPosition = event => {
  const $progress = event.currentTarget;
  const $video = $progress.closest('.js-video');

  hideTooltip(null, $video, $video);
};
